import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import {Box, DialogTitle, IconButton, Stack, Tooltip, Typography} from '@mui/material';
import {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';

interface Props {
    title: string
    subtitle?: string
    onBack?: () => void
    onClose: () => void
    /** Left of close: the search step's Send test. */
    action?: ReactNode
    /** Under the title, inside the header: the search field. */
    children?: ReactNode
}

/** The invite dialog's header on every step: back, the title with one line of meaning, an action, close. */
export default function SurveyInviteHeader({title, subtitle, onBack, onClose, action, children}: Props) {
    const {t} = useTranslation();

    return (
        <DialogTitle sx={{p: 2.5, pb: 2, flexShrink: 0}}>
            <Stack direction={'row'} alignItems={'center'} gap={1}>
                {onBack && (
                    <IconButton aria-label={t('Back')} onClick={onBack} sx={{ml: -1, flexShrink: 0}}>
                        <ArrowBackIcon/>
                    </IconButton>
                )}
                <Box sx={{flex: 1, minWidth: 0}}>
                    <Typography variant={'h6'} fontWeight={600} noWrap sx={{lineHeight: 1.3}}>{title}</Typography>
                    {subtitle && <Typography variant={'body1'} color={'text.secondary'} noWrap>{subtitle}</Typography>}
                </Box>
                {action}
                <Tooltip title={t('Close')}>
                    <IconButton aria-label={t('Close')} onClick={onClose} sx={{flexShrink: 0}}>
                        <CloseIcon/>
                    </IconButton>
                </Tooltip>
            </Stack>
            {children}
        </DialogTitle>
    );
}
